import React, { useState, useEffect, createContext, useMemo, useCallback } from "react";
import ConfigProvider from "antd/lib/config-provider";
import location from "@/services/location";

export const ThemeContext = createContext({
  theme: "light",
  toggleTheme: () => { },
});

export function ThemeProvider ({ children }) {
  const [theme, setTheme] = useState(() => {
    return (location.search && location.search.theme) || localStorage.getItem("theme") || "light";
  });

  useEffect(() => {
    const unlisten = location.listen(loc => {
      if (loc.search.theme) {
        setTheme(loc.search.theme);
      }
    });
    return unlisten;
  }, []);

  useEffect(() => {
    localStorage.setItem("theme", theme);
    const body = document.body;
    if (theme === "dark") {
      body.classList.add("dark-theme");
      body.classList.remove("light-theme");
    } else {
      body.classList.add("light-theme");
      body.classList.remove("dark-theme");
    }

    if (location.search.theme && location.search.theme !== theme) {
      location.setSearch({ theme }, true);
    }
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme(prevTheme => (prevTheme === "light" ? "dark" : "light"));
  }, []);

  const value = useMemo(() => ({ theme, toggleTheme }), [theme, toggleTheme]);

  return (
    <ThemeContext.Provider value={value}>
      {useMemo(() => <ConfigProvider >{children}</ConfigProvider>, [children])}
    </ThemeContext.Provider>
  );
}
